import { defineStore } from 'pinia';
import { IStores } from '@/storePinia/stores/stores/interfaces/IStores';
import { useCitiesStore } from '@/storePinia/stores/cities';

type StoresGetters = {
  getCurrentCityId(state: IStores): string | undefined;
  getActiveCityName(state: IStores): string | undefined;
  getActiveCity(state: IStores): { ID: string; UF_NAME: string } | undefined;
  getStoresFilteredByCity(state: IStores): { cityId: string; cityName: string }[];
  getStoresFilteredByCityAndAmount(state: IStores): { cityId: string; cityName: string }[];
  getCities(state: IStores): { ID: string; UF_NAME: string; active: boolean }[];
};

export const useStoresStore = defineStore<'stores', IStores, StoresGetters>('stores', {
  state: (): IStores => ({
    cities: [],
    currentCityId: null,
    defaultCityId: 2935, // Kyiv by default (city ID in New Post list). According Technical Task - Kyiv is a default city.
    messages: {},
    stores: [],
  }),
  getters: {
    getCurrentCityId: (state) => {
      const citiesStore = useCitiesStore();
      return state.currentCityId ?? citiesStore.userCityId;
    },
    getActiveCityName(state) {
      return (
        // eslint-disable-next-line eqeqeq
        state.cities?.find((el) => el.ID == this.getCurrentCityId)?.UF_NAME ??
        // eslint-disable-next-line eqeqeq
        state.cities?.find((el) => el.ID == state.defaultCityId.toString())?.UF_NAME
      );
    },
    getActiveCity(state) {
      const { cities, defaultCityId } = state;

      return (
        // eslint-disable-next-line eqeqeq
        cities?.find((el) => el.ID == this.getCurrentCityId) ??
        // eslint-disable-next-line eqeqeq
        cities?.find((el) => el.ID == defaultCityId.toString())
      );
    },
    getStoresFilteredByCity(state) {
      const { stores, defaultCityId } = state;
      // eslint-disable-next-line eqeqeq
      let filteredStores = stores?.filter((el) => el.cityId == this.getCurrentCityId);
      /**
       * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
       */
      if (filteredStores?.length === 0) {
        // eslint-disable-next-line eqeqeq
        filteredStores = stores?.filter((el) => el.cityId == defaultCityId.toString());
      }
      return filteredStores;
    },
    getStoresFilteredByCityAndAmount(state) {
      const { stores, defaultCityId } = state;

      /** at first let filter by product availability */
      const filteredStoresByAmount = stores?.filter((el) => el.amount > 0);

      /** secondly let filter by ajax updated current city id */
      let filteredStores = filteredStoresByAmount?.filter(
        // eslint-disable-next-line eqeqeq
        (el) => el.cityId == this.getCurrentCityId
      );

      /** thirdly let filter by first found store city */
      if (filteredStores?.length === 0) {
        filteredStores = filteredStoresByAmount?.filter(
          // eslint-disable-next-line eqeqeq
          (el) => el.cityId == filteredStoresByAmount[0].cityId
        );
        // dispatch('stores/setActiveCityName', filteredStores[0].cityName);
      }
      /**
       * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
       */
      if (filteredStores?.length === 0) {
        filteredStores = filteredStoresByAmount?.filter(
          // eslint-disable-next-line eqeqeq
          (el) => el.cityId == defaultCityId.toString()
        );
      }
      return filteredStores;
    },
    getCities(state) {
      return (
        state.cities?.map((el) => ({
          ...el,
          // eslint-disable-next-line eqeqeq
          active: el.UF_NAME == this.getActiveCityName,
        })) || []
      );
    },
  },
});
